import { CursorValue, StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  gridContainer: {
    cursor: 'move' as CursorValue,
    position: 'absolute',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
    borderWidth: 2,
  },
  corner: {
    width: 24,
    height: 24,
    position: 'absolute',
  },
  cornerTopLeft: {
    top: -4,
    left: -4,
    borderTopWidth: 3,
    borderLeftWidth: 3,
  },
  cornerTopRight: {
    top: -4,
    right: -4,
    borderTopWidth: 3,
    borderRightWidth: 3,
  },
  cornerBottomLeft: {
    bottom: -4,
    left: -4,
    borderBottomWidth: 3,
    borderLeftWidth: 3,
  },
  cornerBottomRight: {
    bottom: -4,
    right: -4,
    borderBottomWidth: 3,
    borderRightWidth: 3,
  },
});
